import { Button, Flex, Spinner, Text, useDisclosure } from '@chakra-ui/react';
import PageCard from '../../../components/page-card';
import { translate } from '../../../i18n';
import { useGetAdminWalletBalance } from '../hooks/useGetAdminWalletBalance';
import AdjustWalletModal from './AdjustWalletModal';

type Props = {
  userId: string;
};

export default function UserWalletSection({ userId }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data, isLoading, isError } = useGetAdminWalletBalance(userId);
  const walletBalance = data?.balance ?? 0;

  return (
    <PageCard
      title={translate('wallet_admin.wallet')}
      rightHeader={
        <Flex align="center" gap={4}>
          <Text fontSize="lg" fontWeight="bold">
            {translate('wallet_admin.balance')}:{' '}
            {isLoading ? (
              <Spinner size="sm" />
            ) : isError ? (
              <Text as="span" color="red.500">{translate('common.error')}</Text>
            ) : (
              walletBalance.toFixed(2)
            )}
          </Text>
          <Button size="sm" colorScheme="brand" onClick={onOpen}>
            {translate('wallet_admin.adjust_balance')}
          </Button>
        </Flex>
      }
    >
      {/* Per-user transaction table removed (epic docs/epics/unified-player-history.md
          D-PLACE / M8, ledger T8@eng-review): UserHistorySection on UserPage
          is a strict superset (proved by UserHistorySection.test.tsx), so
          this card is now balance + adjust action only. */}
      <AdjustWalletModal
        isOpen={isOpen}
        onClose={onClose}
        userId={userId}
        currentBalance={walletBalance}
      />
    </PageCard>
  );
}
